var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavSubtopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 5.02963V12.9458M4.16666 6.66665C2.78594 6.66665 1.66666 7.78593 1.66666 9.16665V13.3333C1.66666 15.1743 3.15904 16.6666 4.99999 16.6666H15C16.8409 16.6666 18.3333 15.1743 18.3333 13.3333V9.16665C18.3333 7.78593 17.214 6.66665 15.8333 6.66665M5.33002 3.33958C6.62407 3.47884 8.36265 3.85349 9.60147 4.68023C9.83956 4.83912 10.1604 4.83912 10.3985 4.68023C11.6373 3.85349 13.3759 3.47884 14.67 3.33958C15.3104 3.27065 15.8333 3.77999 15.8333 4.40841V10.6666C15.8333 11.295 15.3104 11.8046 14.67 11.8735C13.3759 12.0128 11.6373 12.3874 10.3985 13.2141C10.1604 13.373 9.83956 13.373 9.60147 13.2141C8.36265 12.3874 6.62407 12.0128 5.33002 11.8735C4.68957 11.8046 4.16666 11.295 4.16666 10.6666V4.40841C4.16666 3.77999 4.68957 3.27065 5.33002 3.33958Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavSubtopics);
export default __webpack_public_path__ + "static/media/sidenav-subtopics.dd9474afd4fe1437fab605b9321336e4.svg";
export { ForwardRef as ReactComponent };